export { default } from './BatchActionsToolbar';



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionsToolbar/index.js